export const eventsContent = {
  brochureUrl: '/events/hr-tech-asia-2026-delegate-brochure.pdf',
  sourceNotes: [
    'Hero/핵심 수치/트랙/프로그램/가격은 Delegate Brochure 주요 페이지(표지, 프로그램, pricing package) 기반으로 웹용 축약 문구로 재작성.',
    'TODO: 일부 스폰서 개별 로고는 원본 브로셔 이미지 분해가 필요해 현재 티어별 로고 월(집합 이미지)로 우선 구성.',
    'TODO: 참가자 후기는 브로셔 문장을 짧게 재작성했으며, 확정 인용 문구는 최종 검수 후 교체 권장.',
  ],
  hero: {
    kicker: 'HR Tech Asia 2026',
    title: '25년 역사를 자랑하는 아시아 지역 최대 규모의 HR 테크와 Workforce 이벤트',
    subtitle: '25년 역사를 자랑하는 아시아 지역 최대 규모의 HR 테크와 Workforce 이벤트',
    dates: '2026년 5월 4일-7일',
    venue: 'Suntec Singapore Convention & Exhibition Centre',
    chips: ['5,000+ Attendees', '130+ Booths', '4 Tracks', '110+ Sessions', '120+ Speakers'],
  },
  nav: [
    { id: 'events-why', label: '참가 가치' },
    { id: 'events-tracks', label: '트랙' },
    { id: 'events-programme', label: '프로그램' },
    { id: 'events-demographics', label: '참가자 구성' },
    { id: 'events-pricing', label: '참가 요금' },
    { id: 'events-testimonials', label: '후기' },
  ],
  whyAttend: {
    title: '왜 HR Tech Asia인가',
    intro: 'HR Tech Asia는 아시아 전역의 HR리더들과 HR 관련 솔루션 회사 130여개 이상이 참여하여 4일간 진행되는 최대 규모의 행사입니다.',
    bullets: [
      '5,000명이상이 참여하는 최대 규모',
      '컨퍼런스, 엑스포, 마스터 클래스, 어워즈 및 기업체 방문을 포함하는 다양항 형태의 행사를 동시에 진행',
      '110개의 세션과 120명의 연사가 AI, Digital Transformation, 피플애널리틱스 등 다양한 주제와 패널 토의를 진행',
      '2만평방미터의 전시장에서 130여개 회사의 솔루션과 서비스를 만나는 기회 제공',
    ],
  },
  numbers: [
    { value: '5,000+', label: '참가자', span: 'wide' },
    { value: '130+', label: '부스', span: 'normal' },
    { value: '110+', label: '세션', span: 'normal' },
    { value: '120+', label: '연사', span: 'normal' },
    { value: '4', label: '메인 트랙', span: 'normal' },
    { value: '4', label: '마스터클래스', span: 'normal' },
    { value: '20,000+', label: '전시 면적 (sqm)', span: 'wide' },
    { value: '4일', label: '행사 기간', span: 'normal' },
  ],
  tracks: [
    {
      id: 'track-masterclass',
      tab: '사전 마스터클래스',
      period: '5월 4일',
      summary: '실무 적용을 목표로 한 집중형 과정으로, 인증서 발급이 포함됩니다.',
      details: [
        'AI, Digital & Data Science Masterclass',
        'People Analytics Masterclass',
        'Data Privacy & Cybersecurity for HR Masterclass',
        'Redefining Jobs & Automation in an AI Era',
      ],
    },
    {
      id: 'track-csuite',
      tab: 'C-Suite Leadership',
      period: '5월 5-6일',
      summary: 'CHRO/CPO/경영진 관점에서 인재 전략과 조직 운영 의사결정을 다룹니다.',
      details: [
        '키노트 및 C-Suite 패널',
        'People Strategy, 조직 전환, 리더십 실행 세션',
        '전략 라운드테이블 및 토론 세션',
      ],
    },
    {
      id: 'track-workforce',
      tab: 'Workforce Transformation',
      period: '5월 5-6일',
      summary: '역량 전환, 운영 모델 재설계, 협업 방식 혁신을 중심으로 사례를 공유합니다.',
      details: [
        'Workforce Planning 및 조직 변화 사례',
        '리스킬링·업스킬링 실행 전략',
        '실무자 중심 토론 세션',
      ],
    },
    {
      id: 'track-worktech',
      tab: 'Worktech & AI',
      period: '5월 5-6일',
      summary: 'HR 솔루션과 AI 기술의 도입/확장 사례를 현장 중심으로 연결합니다.',
      details: [
        'Worktech 제품 데모 및 엑스포 연결',
        'AI 기반 HR 운영 사례',
        '스타트업 허브 및 파워톡',
      ],
    },
  ],
  programme: [
    {
      day: '4 May 2026',
      title: 'Pre-Event Masterclasses',
      summary: '4개 인증 과정으로 실무형 사전 학습 트랙 운영',
      highlights: ['AI/Data', 'People Analytics', 'Data Privacy', 'Automation'],
    },
    {
      day: '5-6 May 2026',
      title: 'Main Conference + Expo',
      summary: '키노트, 4개 트랙, 엑스포, 파워톡, 어워즈를 통합 운영',
      highlights: ['C-Suite Leadership', 'Workforce Transformation', 'Worktech & AI', 'Power Talks'],
    },
    {
      day: '7 May 2026',
      title: 'Post-Event Site Tours',
      summary: '현장 중심 벤치마킹 프로그램',
      highlights: ['AWS Innovation Hub', 'Ubisoft Singapore', 'Catapult', 'NTT DATA Business Solutions'],
    },
  ],
  demographics: {
    groups: [
      {
        title: '참가자 구성',
        bars: [
          { label: '컨퍼런스 참가자', value: 75.2 },
          { label: 'C-Suite', value: 14.6 },
          { label: '참관객', value: 10.2 },
        ],
      },
      {
        title: '지역 비중',
        bars: [
          { label: '싱가포르', value: 74.9 },
          { label: '동남아(싱가포르 제외)', value: 13.3 },
          { label: '동아시아', value: 4.7 },
        ],
      },
    ],
    notes: ['2만 평방미터 규모 전시장', '130여 개 솔루션 기업 참여'],
  },
  pricing: {
    tickets: [
      {
        type: 'Conference All-Access Pass',
        date: '5-6 May 2026',
        regular: 'SGD 1,399',
      },
      {
        type: 'Expo Pass (HR 직무 대상)',
        date: '5-6 May 2026',
        regular: 'SGD 60',
      },
      {
        type: 'Vendor Expo Pass',
        date: '5-6 May 2026',
        regular: 'SGD 1,000',
      },
      {
        type: 'Pre-Event Masterclasses',
        date: '4 May 2026',
        regular: 'SGD 999',
      },
      {
        type: 'Post-Event Site Tours',
        date: '7 May 2026',
        regular: 'SGD 499',
      },
    ],
    groupDiscounts: ['5-19 tickets: 10% discount', '20-49 tickets: 15% discount', '50+ tickets: 20% discount'],
    note: 'TODO: 그룹 할인/혜택 조건 최종 문구는 운영팀 확정본으로 교체 필요',
  },
  sponsors: [
    { tier: 'Platinum', src: '/events/sponsors/logos-platinum.png' },
    { tier: 'Gold', src: '/events/sponsors/logos-gold.png' },
    { tier: 'Silver', src: '/events/sponsors/logos-silver.png' },
    { tier: 'Associate', src: '/events/sponsors/logos-associate.png' },
    { tier: 'Exhibitors', src: '/events/sponsors/logos-exhibitors.png' },
    { tier: 'Startup', src: '/events/sponsors/logos-startup.png' },
    { tier: 'Partners', src: '/events/sponsors/logos-partners-core.png' },
  ],
  testimonials: [
    {
      quote: '행사 규모와 세션 밀도가 높아, 이틀 동안 업계 핵심 흐름을 압축적으로 파악할 수 있었습니다.',
      author: 'HR Director, Regional Enterprise',
    },
    {
      quote: '단순 트렌드 소개가 아니라 실제 적용 사례 중심이라 조직 내 실행 계획 수립에 큰 도움이 되었습니다.',
      author: 'People Analytics Lead',
    },
    {
      quote: '엑스포와 세션, 네트워킹이 자연스럽게 연결되어 파트너 발굴 효율이 높았습니다.',
      author: 'Solution Partner',
    },
    {
      quote: 'C-Suite 관점과 실무 관점이 함께 제공되어 팀 전체 의사결정 정렬에 유익했습니다.',
      author: 'CHRO Office',
    },
  ],
  finalCta: {
    title: 'HR Tech Asia 2026에 지금 등록하세요',
    text: '아시아 HR Tech 리더들과 함께 다음 1년의 전략과 실행 우선순위를 선점하세요.',
    registerUrl: 'https://www.hrtechfestivalasia.com/register',
    contactEmail: 'info@hrmasia.com.sg',
    contactPhone: '(+65) 9710 3009',
  },
};
